import { z } from "zod";

import { apiClient } from "./client.ts";

export const MeResponse = z.object({
  user: z
    .object({
      id: z.string(),
      email: z.string().nullable(),
      name: z.string().nullable(),
      avatarUrl: z.string().nullable(),
      role: z.enum(["admin", "member", "viewer"]),
      identities: z.array(
        z.object({
          provider: z.string(),
          handle: z.string().nullable(),
          email: z.string().nullable(),
        }),
      ),
      memberships: z.array(
        z.object({
          teamId: z.string(),
          role: z.string(),
          source: z.string(),
        }),
      ),
    })
    .nullable(),
  session: z
    .object({
      provider: z.string(),
      expiresAt: z.string(),
    })
    .nullable(),
  ssoConfigured: z.boolean(),
  adminTokenLoginEnabled: z.boolean(),
});
export type MeResponse = z.infer<typeof MeResponse>;

export const authApi = {
  me: () => apiClient.get("/api/auth/me", MeResponse),
  tokenLogin: (token: string) =>
    apiClient.post(
      "/api/auth/token-login",
      { token },
      z.object({ ok: z.literal(true) }),
    ),
  logout: () => apiClient.post("/api/auth/logout", undefined, z.object({ ok: z.literal(true) })),
};

export function oidcLoginUrl(returnTo?: string): string {
  const params = returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : "";
  return `/api/auth/login${params}`;
}
